<template>
  <div
    class="relative gap-4 border border-gray-200 rounded-xl hover:border-tuin-100 transition-colors h-[310px] w-full"
    :class="{ 'border-tuin-100': props.row.is_checked }"
  >
    <div>
      <div v-if="row.image == 0 || row.image == null" class="h-[157px] p-5 w-full rounded-xl overflow-hidden bg-[#f2f3f2]">
        <img
          src="@/assets/imgs/default_image.svg"
          alt="Sin imagen"
          class="w-full h-full object-fit-cover"
        >
      </div>
      <div v-else-if="row.image" class="h-[157px] w-full rounded-xl overflow-hidden bg-[#f2f3f2]">
        <img
          :src="row.image"
          :alt="row.property_name"
          class="w-full h-full object-cover"
        >
      </div>
    </div>

    <input
      :checked="row.is_checked"
      @change="onChange($event)" 
      id="is_checked_box"
      type="checkbox" 
      class="absolute top-3 right-3 w-5 h-5 text-tuin_base-0 bg-gray-100 border-gray-300 rounded-full focus:ring-transparent cursor-pointer"
    >

    <div class="px-4 py-2">
      <div class="mb-1">
        <span class="inline-block bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-md">
          {{ row.status }}
        </span>
      </div>

      <div class="mb-1">
        <span
          v-if="row.is_owner !== true" 
          class="block bg-gray-800 text-white text-xs font-normal px-2.5 py-0.5 rounded-lg truncate"
        >
          <span class="font-medium">Asesor:</span>
          {{ row.agent_name }}
        </span>
      </div>

      <h3 class="text-gray-900 text-sm font-semibold truncate overflow-hidden whitespace-nowrap">
        {{ row.property_name }}
      </h3>

      <p class="text-sm font-normal text-gray-900 truncate overflow-hidden whitespace-nowrap">
        {{ row.address != ", , " ? row.address : "" }}
      </p>

      <div class="flex">
        <div
          v-if="row.type_movement_id === 3"
          class="text-black text-sm font-semibold gap-2"
        >
          <div>
            <span class="text-sm font-normal">Venta </span>{{ row.property_value }}
            <span class="text-xs font-normal"> {{ row.currency_code || row.currency }}</span>
          </div>
          <div>
            <span class="text-sm font-normal">Renta </span>{{ row.rent_value }}
            <span class="text-xs font-normal"> {{ row.currency_code || row.currency }}</span>
          </div>
        </div>
        <!-- Solo venta (1 o 5) -->
        <div
          v-else-if="row.type_movement_id === 1 || row.type_movement_id === 5 || row.type_movement_id === 2 || row.type_movement_id === 4"
          class="text-black text-sm font-semibold"
        >
          <span class="text-sm font-normal">{{ row.type_movement_name }} </span> {{ row.property_value }}
          <span class="text-xs font-normal">{{ row.currency_code || row.currency }}</span>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script setup>
const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['addProperty']);

const onChange = (event) => {
  emit('addProperty', {
    id: props.row.id,
    checked: event.target.checked
  })
}
</script>
